import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, createVNode as _createVNode, Transition as _Transition, withCtx as _withCtx, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "navBlock" }
const _hoisted_2 = ["src"]
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "navAnchors" }
const _hoisted_5 = { class: "contactBlock" }
const _hoisted_6 = { class: "emailForm" }
const _hoisted_7 = { class: "legalBlock" }

import { inject, computed, ref, reactive } from "vue";
import SocialIcons from "../layouts/SocialIcons.vue";

export default /*@__PURE__*/_defineComponent({
  __name: 'TheFooter',
  setup(__props) {

const displayWidth: any = inject(`displayWidth`);
const store: any = inject(`store`);
const router:any =inject(`router`)
const anchorList = store.getters.getNavAnchorList;
const showDialog = ref(false);
const isPending = ref(false);
const inputElement = ref();
const value = reactive({ status: ``, text: `` });
const providedData = reactive({ value: ``, valid: false });

const computedDisplayWidth = computed(() => {
  return displayWidth.value < 700;
});

function sendTo(to: string) {
  if(router.currentRoute.value.path!==`/home`){
    router.go(-1)
  }
  setTimeout(()=>{
    store.dispatch(`scrollToAction`, to);
  },10) 
}

function checkValues() {
  if (providedData.value.match(
      /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/g /* eslint-disable-line */
    )
  ) {
    inputElement.value.style.border = ``;
    providedData.valid = true;
    
  } else {
    inputElement.value.style.border = `1px solid red`;
    providedData.valid = false;
  }
}

async function send() {
  checkValues()
  if(providedData.valid){
  isPending.value=true
  const returned = await store.dispatch(`sendRequest`, providedData.value);
    if(returned){
      value.status = `Success`;
      value.text = `Your Email was Saved`;
      providedData.value = ``;
    }else{
      value.status = `Error`;
      value.text = `Please try send Email later`;
    }
    isPending.value = false;
    showDialog.value = true;
    setTimeout(() => {
      showDialog.value = false;
    }, 2500);
  }
}

return (_ctx: any,_cache: any) => {
  const _component_BaseAnchor = _resolveComponent("BaseAnchor")!
  const _component_PendingButton = _resolveComponent("PendingButton")!
  const _component_MiniDialog = _resolveComponent("MiniDialog")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([`footerWrapper`, { footerWrapperMobile: computedDisplayWidth.value }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: "logo",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (sendTo(`about`)))
      }, [
        _createElementVNode("img", {
          class: "first",
          src: require(`../assets/Vector.png`),
          alt: "Positivus Logo"
        }, null, 8, _hoisted_2),
        _createElementVNode("img", {
          class: "second",
          src: require(`../assets/Positivus.png`),
          alt: "Positivus Logo"
        }, null, 8, _hoisted_3)
      ]),
      _createElementVNode("div", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(anchorList), (anchor) => {
          return (_openBlock(), _createBlock(_component_BaseAnchor, {
            class: "anchor",
            theme: "white",
            text: anchor.text,
            key: anchor.text,
            onClick: ($event: any) => (sendTo(anchor.to))
          }, null, 8, ["text", "onClick"]))
        }), 128))
      ]),
      (!computedDisplayWidth.value)
        ? (_openBlock(), _createBlock(SocialIcons, { key: 0 }))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _cache[3] || (_cache[3] = _createStaticVNode("<div class=\"adressBlock\" data-v-c6bfa1f0><span class=\"label\" data-v-c6bfa1f0>Contact us:</span><p class=\"adress\" data-v-c6bfa1f0>Email: info@positivus.com</p><p class=\"adress\" data-v-c6bfa1f0>Phone: 555-567-8901</p><p class=\"adress\" data-v-c6bfa1f0> Address: 1234 Main St <br data-v-c6bfa1f0> Moonstone City, Stardust State 12345 </p></div>", 1)),
      _createElementVNode("div", _hoisted_6, [
        _withDirectives(_createElementVNode("input", {
          class: "input",
          type: "email",
          placeholder: "Email",
          id: "email",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((providedData.value) = $event)),
          onBlur: checkValues,
          ref_key: "inputElement",
          ref: inputElement
        }, null, 544), [
          [_vModelText, providedData.value]
        ]),
        _createVNode(_component_PendingButton, {
          isPending: isPending.value,
          send: send,
          text: "Subscribe to news",
          color: "green",
          class: "baseButton"
        }, null, 8, ["isPending"])
      ])
    ]),
    (computedDisplayWidth.value)
      ? (_openBlock(), _createBlock(SocialIcons, {
          key: 0,
          class: "socialIcons"
        }))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_7, [
      _cache[4] || (_cache[4] = _createElementVNode("p", { class: "year" }, "© 2023 Positivus. All Rights Reserved.", -1)),
      _createVNode(_component_BaseAnchor, {
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(router).push({path:`/PrivacyPolicy`,query:{name:`Privacy policy`}}))),
        class: "privacy",
        text: "Privacy Policy"
      })
    ]),
    _createVNode(_Transition, null, {
      default: _withCtx(() => [
        (showDialog.value)
          ? (_openBlock(), _createBlock(_component_MiniDialog, {
              key: 0,
              values: value
            }, null, 8, ["values"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ], 2))
}
}

})